import { render } from "./bankData.vue?vue&type=template&id=3b3992ea"
import script from "./bankData.vue?vue&type=script&lang=js"
export * from "./bankData.vue?vue&type=script&lang=js"

import "./bankData.vue?vue&type=style&index=0&id=3b3992ea&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__